/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

export type TrackVersionListType =
  (typeof TrackVersionListType)[keyof typeof TrackVersionListType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrackVersionListType = {
  A: "A",
  B: "B",
  C: "C",
} as const;
